import { useQuery } from '@tanstack/react-query';

export const useStudentCourseTotal = (apiHost, courseId) => {
  return useQuery({
    queryKey: ['course-total', courseId],
    queryFn: async () => {
      const response = await fetch(
        `${apiHost}/api/v1/dashboards/courses/${courseId}/course-total-widget`,
        {
          method: 'GET',
          credentials: 'include',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Pragma: 'no-cache',
          },
        }
      );
      if (!response.ok) {
        throw new Error('Failed to fetch student course total');
      }
      return response.json();
    },
    enabled: Boolean(apiHost && courseId),
  });
};
